import { animate, scroll } from "motion"

export const dualImage = (element) => {

  const image = element.querySelector('img');
  const scrollOptions = {
    target: element,
    offset: ["25% end", "85% end"]
  }

  if (window.matchMedia("(min-width: 1024px)").matches) {
    scroll(
      animate(image, { clipPath: ["polygon(0 0, 100% 0, 100% 100%, 0% 100%)", "polygon(0 0, 50% 0, 50% 100%, 0% 100%)"] }),
      scrollOptions
    );
  } else {
    scroll(
      animate(image, { clipPath: ["polygon(0 0, 100% 0, 100% 100%, 0% 100%)", "polygon(0 0, 0% 0, 0% 100%, 0% 100%)"] }),
      scrollOptions
    );
  }
}